import { Injectable, inject, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ResultService } from '@ukam/core/services/result.service';
import { CacheService } from '@ukam/core/services/cache.service';
import { FilterSupportApiService } from './filter-support-api.service';
import { FilterSupportData } from '../models/filter-support';

@Injectable({ providedIn: 'root' })
export class FilterSupportService {
  private resultService = inject(ResultService);
  private apiService = inject(FilterSupportApiService);
  private cacheService = inject(CacheService);

  public loading = signal(false);
  public data = signal<FilterSupportData | null>(null);

  constructor() {
    this.cacheService.register(() => this.clear());
  }

  load(reload = false): Observable<FilterSupportData> {
    if (!reload && this.data() !== null) {
      return of(this.data()!);
    }

    this.loading.set(true);
    return this.apiService.getSupport().pipe(
      tap((result) => {
        this.data.set(result);
        this.loading.set(false);
      }),
      catchError((error) => {
        this.resultService.showError(error);
        this.loading.set(false);
        throw error;
      }),
    );
  }

  clear(): void {
    this.data.set(null);
    this.loading.set(false);
  }

}
